import React, { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap'
import Moment from 'moment'
import Loader from 'react-loader-spinner'
import Card, { CardHeader } from 'react-bootstrap/Card'

const ViewHistoricalComponent = props => {
  const [deleteVal, setDeleteVal] = useState(false)
  const [downloadPdfVal, setDownloadPdfVal] = useState(false)

  const setDeleteFunc = () => {
    if (!deleteVal) {
      setDeleteVal(true)
    } else {
      setDeleteVal(false)
    }
  }
  useEffect(() => {
    if (deleteVal) {
      props.DeleteNurseRecord(props.record.id)
    }
  }, [deleteVal])

  const downloadPdfFunc = () => {
    if (!downloadPdfVal) {
      setDownloadPdfVal(true)
    } else {
      setDownloadPdfVal(false)
    }
  }


  useEffect(() => {
    if (downloadPdfVal) {
      props.getHistoricalRecordsWithPdf(props.record.id)
    }
  }, [downloadPdfVal])
  return (
    <>
      <Card>
        <Card.Header>
          <strong><h5> {props.record.firstName} {props.record.lastName}</h5></strong></Card.Header>
        <Card.Body>
          <Card.Title>{props.record.skillsTestName}</Card.Title>

          <p>Candidate email:<br/> {props.record.nurseEmail}</p>
          <p>Candidate phone: {props.record.phoneNumber}</p>
          <p>Chosen Recruiter:<br/> {props.record.recruiterEmail}</p>
          <p>Completed: {Moment(props.record.timeSubmitted).format('MMMM Do, YYYY')}</p>
          <hr />
          <Button download='test' variant='primary' onClick={downloadPdfFunc}>
            Get PDF
          </Button>
          {/*<Button onClick={setDeleteFunc} variant="danger">*/}
          {/*    Delete*/}
          {/*</Button>*/}

        </Card.Body>
      </Card>
    </>
  )
}

export default ViewHistoricalComponent
